import React, {useEffect, useState} from "react";

interface ContentGraphic {
  headline: string;
  text: string;
  el:string;
  image: {
    url: string;
    altText: string;
  };
}

const Graphic = (props: ContentGraphic) => {
  const { headline, text, image, el } = props;
  const [styleDividing, setStyleDividing] = useState('');

  useEffect(() => {
    if ((headline === undefined && text !== undefined && text.length > 0) ||
        (text === undefined && headline !== undefined)) {
      setStyleDividing('text');
    } else if (headline !== undefined && text !== undefined) {
      setStyleDividing('headline');
    } else {
      setStyleDividing(' ');
    }
  });

  return (
    <>
      <div className={`graphic ${el}`}>
        <div className="graphic__image">
          <img className="av-topic-line__image" src={image.url} alt={image.altText}/>
        </div>
        {(headline || text) &&
          <div  className="graphic__content">
            { headline &&
              <div className="graphic__headline">
                <p className={`hl-4 ${styleDividing}`}>
                  <strong dangerouslySetInnerHTML={{__html: headline || ''}}/>
                </p>
              </div>
            }
            { text &&
              <div className="graphic__text tx-1" dangerouslySetInnerHTML={{__html: text || ''}}/>
            }
          </div>
        }
      </div>
    </>
  )
};

export default Graphic;
